import { Component, HostListener, Input, OnInit } from '@angular/core';
import {
  Scorecard,
  ScorecardMilestone,
  ScorecardMilestoneActionDisplayType,
  ScorecardMilestoneDetails,
  ScorecardQuery,
  ScorecardService,
} from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionComponent } from '../../scorecard-description/scorecard-description.component';
import { Router } from '@angular/router';
@Component({
  selector: 'fgbcl-milestones-progress-view',
  templateUrl: './milestones-progress-view.component.html',
  styleUrls: ['./milestones-progress-view.component.scss', '../../scorecard-display-types/scorecard-display-shared.scss'],
})
export class MilestonesProgressViewComponent implements OnInit {
  @Input() originScorecard: Scorecard;
  scorecard: Scorecard;
  @Input() confettiColors: string[];
  @Input() icon: string = 'info';
  @Input() disabled: boolean = false;
  @Input() isSponsorInBody: boolean = false;
  maxMilestone: number = 0;
  allMilestoneSpacing: number[] = [];
  currentProgressValue: number = 0;
  alignmentOfMilestoneValue = 0;
  isOpenModal: boolean = true;
  isScorecardHasChild: boolean = false;
  isMilestoneNotReachedTwoLastest: boolean = false;
  alignMilestoneNotReachedTwoLastest: number = 0;
  alignmentOfMilestoneCircle = 0;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private router: Router,
    private scorecardService: ScorecardService,
    private scorecardQuery: ScorecardQuery
  ) {}

  ngOnInit(): void {
    if (!!this.originScorecard?.Milestone) {
      this.scorecard = JSON.parse(JSON.stringify(this.originScorecard));
      this.maxMilestone = this.getMaxMilestone();
      this.scorecard.Milestone = this.sliceMilestone(this.scorecard.Milestone);
      this.getMilestoneSpacing();
      this.getCurrentValueOfProgressBar();
      this.getMilestoneValueSpacing(window.screen.width);
      this.isScorecardHasChild = this.scorecardQuery.hasLinkedScorecards(this.scorecard.ScorecardId);
      this.onWindowResize(window.innerWidth);
    }
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 576) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  // slice milestone into 3 actions if milesone have more than 3 action
  sliceMilestone(milestone: ScorecardMilestone) {
    let newMilestone = JSON.parse(JSON.stringify(milestone)) as ScorecardMilestone;
    let milestones = newMilestone.Milestones;
    let currentValue = newMilestone.CustomerValue;
    let milestoneLength = milestones.length;
    let lastValueOriginMilestone = milestones[milestones.length - 1];
    let isSegmentMilestone = newMilestone.MilestoneActionDisplayType == ScorecardMilestoneActionDisplayType.segment;
    if (isSegmentMilestone && milestoneLength > 3) {
      // no action is done, length = 3
      if (currentValue == 0) {
        milestones.length = 3;
      }
      // some actions are done but still have more than 2 actions, get current and two more
      if (currentValue && currentValue <= milestoneLength - 2) {
        milestones = milestones?.slice(currentValue - 1, currentValue + 2);
      }
      // only have one more action
      if (currentValue && currentValue == milestoneLength - 1) {
        milestones = milestones?.slice(currentValue - 2, currentValue + 1);
      }
      // if milestone not reached two last step, set isMilestoneNotReachedTwoLastest = true to push circle and value to left
      if (lastValueOriginMilestone !== milestones[milestones.length - 1]) {
        this.isMilestoneNotReachedTwoLastest = true;
      }
      // if milestone is done, get 3 lastest
      if (currentValue == milestones.length) {
        milestones = milestones.slice(-3);
      }
    }
    newMilestone.Milestones = milestones;
    return newMilestone;
  }

  /**
   * Calculate value of
   * progress bar.
   */
  getCurrentValueOfProgressBar() {
    if (this.scorecard.Milestone.MilestoneActionDisplayType === ScorecardMilestoneActionDisplayType.segment) {
      this.calculateProgressBySegment();
    } else {
      this.currentProgressValue = (this.scorecard.Milestone.CustomerValue * 100) / this.maxMilestone;
    }
  }

  /**
   * Calculate value of
   * progress bar by segment.
   */
  calculateProgressBySegment() {
    let differenceBetweenMilestones = (1 / this.scorecard.Milestone.Milestones.length) * 100;

    this.scorecard.Milestone.Milestones.every((milestone, i) => {
      if (this.scorecard.Milestone.CustomerValue >= milestone.Value) {
        this.currentProgressValue = this.allMilestoneSpacing[i];

        return true;
      } else {
        let currentSegmentTotal = 0;
        let progressInCurrentSegment = 0;

        if (i === 0) {
          currentSegmentTotal = this.scorecard.Milestone.Milestones[0].Value;
          progressInCurrentSegment = this.scorecard.Milestone.CustomerValue;
        } else {
          currentSegmentTotal = milestone.Value - this.scorecard.Milestone.Milestones[i - 1].Value;
          progressInCurrentSegment = this.scorecard.Milestone.CustomerValue - this.scorecard.Milestone.Milestones[i - 1].Value;
        }

        this.currentProgressValue =
          this.currentProgressValue + (progressInCurrentSegment / currentSegmentTotal) * differenceBetweenMilestones;

        return false;
      }
    });
  }

  /**
   * Gets max milestone value from
   * the highest value of milestones.
   * @returns Max milestone value
   */
  getMaxMilestone() {
    return Math.max.apply(
      Math,
      this.originScorecard?.Milestone?.Milestones?.map(function (milestone: ScorecardMilestoneDetails) {
        return milestone.Value;
      })
    );
  }

  /**
   * Get accurate spacing
   * between milestones.
   * Will calculate spacing
   * depending on milestone display
   * type. e.g. segment view or
   * value view.
   */
  getMilestoneSpacing() {
    this.scorecard.Milestone.Milestones.forEach((action: any, i: any) => {
      let spacingCalculated = 0;
      if (this.scorecard.Milestone.MilestoneActionDisplayType === ScorecardMilestoneActionDisplayType.segment) {
        spacingCalculated = ((i + 1) / this.scorecard.Milestone.Milestones.length) * 100;
      } else {
        spacingCalculated = (this.scorecard.Milestone.Milestones[i].Value / this.maxMilestone) * 100;
      }

      this.allMilestoneSpacing.push(spacingCalculated);
    });
  }

  /**
   * Calculate spacing
   * between milestone values
   * under the progress bar
   * according to screen size.
   */
  @HostListener('window:resize', ['$event.target.screen.width'])
  getMilestoneValueSpacing(event: number) {
    if (event > 991) {
      this.alignmentOfMilestoneValue = 2.5;
      this.alignmentOfMilestoneCircle = 4.5;
      this.alignMilestoneNotReachedTwoLastest = 5;
    }
    if (event <= 425) {
      this.alignmentOfMilestoneValue = 1.5;
      this.alignmentOfMilestoneCircle = 3;
      this.alignMilestoneNotReachedTwoLastest = 4;
    }
    if (event <= 991 && event > 425) {
      this.alignmentOfMilestoneValue = 0.5;
      this.alignmentOfMilestoneCircle = 1;
      this.alignMilestoneNotReachedTwoLastest = 2;
    }
  }

  /**
   * Open scorecard description
   * modal.
   */
  openScorecardDescription() {
    if (!this.disabled) {
      this.isOpenModal ? this.openModal() : this.redirectComponent();
    }
  }

  openModal() {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = this.scorecard.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    const initVal = {
      confettiColors: this.confettiColors,
    };
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};

    this.scorecardService.initDataScorecardDescription$.next(initVal);
    this.router.navigate(['/scorecard-description', this.scorecard.ScorecardId, params]);
  }
}
